module.exports = __webpack_public_path__ + "img/1-1.4c60e584.jpg";